import React from 'react';
import { withStyles } from '@material-ui/core';
import { Button, IconArrow } from 'gatorcomponents';
import { useResize } from '@/hooks/useResize';
import styles from './styles';
import upgradeVps from '@/media/hostingAndServers/upgrade-vps.png';
import upgradeVpsMobile from '@/media/hostingAndServers/upgrade-vps-mobile.png';

const ChangePlanVpsOciCard = ({
  classes,
  locales,
  onGoToForm,
}) => {
  const windowRect = useResize();
  const { width } = windowRect;
  const isMobile = width < 960;

  const handleGoToForm = () => {
    onGoToForm && onGoToForm();
  };

  return (
    <div className={classes.card}>
      <div className={classes.content}>
        <div className={classes.blockText}>
          <h3 className={classes.title}>{locales.title}</h3>
          <p className={classes.description}>{locales.description}</p>

          <div className={classes.actions}>
            <Button
              onClick={handleGoToForm}
              data-testid="btn-card-hire-update-vps"
              label={locales.buttonLabel}
              variant="primary"
              size="large"
              width={isMobile ? 'full' : 'fit-content'}
              iconRight={<IconArrow direction="right" />}
              version="v2"
            />
          </div>
        </div>
        <div className={classes.blockImage}>
          <img src={isMobile ? upgradeVpsMobile : upgradeVps} alt={locales.title} className={classes.Image} />
        </div>
      </div>
    </div>
  );
};

export default withStyles(styles)(ChangePlanVpsOciCard);
